// extracted by mini-css-extract-plugin
export default {"Section":"_Section--vhGqL","SaveToAddressBook":"_SaveToAddressBook--HRW0d","ActionButtons":"_ActionButtons--rIqhK"};